import { Link } from 'react-router-dom';
import { brand } from '../brand/brand';

/**
 * The dark footer card from Direction B, inside the page gutter so it matches
 * the header's floating treatment.
 *
 * The legal links live here because this is where people look for them, and
 * because a payments product that hides its terms invites exactly the dispute it
 * cannot win. The operating company is named for the same reason: someone handing
 * over money is entitled to know who is holding it, and app-store reviewers reject
 * listings that do not say.
 */
export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="inner">
        <div className="footer-cols">
          <div>
            {/* The colour is a class, not an inline literal: the footer card is
                dark in both themes, so it needs --c-on-dark rather than a hex that
                nothing can re-theme. */}
            <span className="wordmark on-dark">{brand.name}</span>
            <p style={{ marginTop: 10, maxWidth: '30ch' }}>{brand.description}</p>
          </div>

          <nav aria-label="For shoppers">
            <h3>Shoppers</h3>
            <div className="stack">
              <Link to="/">Browse deals</Link>
              <Link to="/how-it-works">How it works</Link>
              <Link to="/vouchers">My vouchers</Link>
              <Link to="/faq">FAQ</Link>
            </div>
          </nav>

          <nav aria-label="For businesses">
            <h3>Businesses</h3>
            <div className="stack">
              {/* Honest hrefs. The business console is a separate app that is not
                  built yet; pointing these at "#" would look finished and do
                  nothing, so they go to the pages that actually explain things. */}
              <Link to="/how-it-works">Sell with us</Link>
              <Link to="/support">Talk to us</Link>
            </div>
          </nav>

          <nav aria-label="Company">
            <h3>Company</h3>
            <div className="stack">
              <Link to="/support">Support</Link>
              <Link to="/sms">Deals by text</Link>
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
            </div>
          </nav>
        </div>

        <div className="footer-legal">
          <p>
            © {brand.copyrightFrom === year ? year : `${brand.copyrightFrom}–${year}`}{' '}
            {brand.legalEntity}. Vouchers are sold by the businesses listed and are
            redeemable with them.
          </p>

          {/* .length, not `!== ''`. brand.ts is generated `as const`, so the field
              has a LITERAL type and comparing it to '' is a compile error. */}
          {brand.supportEmail.length > 0 && (
            <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>
          )}
        </div>
      </div>
    </footer>
  );
}
